import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ChevronRight, Shield, Smartphone, Cable, Headphones } from "lucide-react";
import api from "../api/axios";
import CategoryCard from "../components/CategoryCard";
import ProductCard from "../components/ProductCard";

export default function Home() {
  const [categories, setCategories] = useState([]);
  const [products, setProducts] = useState([]);
  const [activeCat, setActiveCat] = useState("all");

  useEffect(() => {
    api.get("/categories").then((res) => setCategories(res.data));
  }, []);

  useEffect(() => {
    api.get("/products", { params: { category: activeCat, limit: 12 } })
      .then((res) => setProducts(res.data.products))
      .catch(() => setProducts([]));
  }, [activeCat]);

  return (
    <div>
      <section className="relative max-w-7xl mx-auto px-4 sm:px-6 pt-16 pb-20 overflow-hidden">
        <div className="absolute inset-0 opacity-[0.06] pointer-events-none" style={{
          backgroundImage: "linear-gradient(#fff 1px, transparent 1px), linear-gradient(90deg, #fff 1px, transparent 1px)",
          backgroundSize: "40px 40px",
        }} />
        <div className="relative max-w-2xl">
          <div className="inline-flex items-center gap-2 font-mono text-xs text-mint border border-mint/30 rounded-full px-3 py-1 mb-6">
            <span className="w-1.5 h-1.5 rounded-full bg-mint animate-pulse" /> IN STOCK & SHIPPING TODAY
          </div>
          <h1 className="font-display font-bold text-5xl sm:text-6xl leading-[0.98] tracking-tight mb-6">
            Every part of<br />your setup.<br />
            <span className="text-accent">Engineered.</span>
          </h1>
          <p className="text-white/60 text-lg mb-8">
            Cases, cables, power, audio, and mounts — sourced, tested, and specced out so you don't have to guess.
          </p>
          <a href="#shop" className="inline-flex items-center gap-2 bg-accent hover:bg-orange-500 text-black font-semibold rounded-full px-6 py-3 text-sm transition">
            Shop all categories <ChevronRight size={16} />
          </a>
        </div>
      </section>

      <section id="shop" className="max-w-7xl mx-auto px-4 sm:px-6 pb-4">
        <h2 className="font-display font-semibold text-xl mb-4">Browse categories</h2>
        <div className="flex gap-3 overflow-x-auto scrollbar-hide pb-4">
          <button
            onClick={() => setActiveCat("all")}
            className={`shrink-0 rounded-2xl px-5 py-4 border transition text-sm font-medium ${
              activeCat === "all" ? "bg-white text-black border-white" : "bg-white/5 border-white/10 hover:border-white/30"
            }`}
          >
            All Products
          </button>
          {categories.map((cat, i) => (
            <CategoryCard
              key={cat._id}
              category={cat}
              index={i}
              active={activeCat === cat.slug}
              onClick={() => setActiveCat(cat.slug)}
            />
          ))}
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-4 sm:px-6 pb-24">
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
          {products.map((p) => <ProductCard key={p._id} product={p} />)}
        </div>
        {products.length === 0 && (
          <p className="text-center py-20 text-white/40 font-mono text-sm">
            No products yet — run <code>npm run seed</code> in the backend to load sample data.
          </p>
        )}
      </section>
    </div>
  );
}
